import { getClassi, getMateria, LEZIONE, MEMBER, renderAutori } from 'utils'
import React from 'react'
import { IoplusBar } from './atomic/Ioplus'
import { Tassonomia } from 'react-components/molecules'
import { useTrans } from 'hooks'
import { CatLibro, Time } from 'react-components/atoms/Icons'

const ArticoloHead = React.memo(({ articolo }) => {
  const t = useTrans()

  const autoreLabel = renderAutori(articolo.utenti, 'articolo-page__info')

  const materia = getMateria(articolo.tassonomia)
  const classe = getClassi(articolo.tassonomia).join('-')

  return (
    <div className="articolo-page__head">
      {articolo.membership == MEMBER ? <IoplusBar white={articolo.tipologia === LEZIONE} /> : null}
      {articolo.tipologia === LEZIONE && (
        <Tassonomia label={'Lezione'} iconName={`cat-scheda`} materia={materia} classe={classe} />
      )}
      <h1 className="articolo-page__title">{articolo.titolo}</h1>
      <p className="articolo-page__abstract">{articolo.descrizione}</p>
      <div className="articolo-page__info" suppressHydrationWarning>
        {articolo.tipologia !== LEZIONE && <CatLibro />}
        {autoreLabel}
        <span className="articolo-page__info__date">{articolo.data_pubblicazione}</span>
        {articolo.tipologia === LEZIONE ? (
          articolo.tag_lezione && (
            <span className="articolo-page__info__tag">{articolo.tag_lezione}</span>
          )
        ) : (
          <span className="articolo-page__info__readtime">
            <Time />
            {articolo.read_time}{' '}
            {articolo.read_time === 1 ? t('minuto di lettura') : t('minuti di lettura')}
          </span>
        )}
      </div>
    </div>
  )
})

export default ArticoloHead
